import { c as _c } from "react/compiler-runtime";
import type { MemberKickOutMessage } from '@module/types/centrifuge/public-message/etcMessageTypes';
interface Props {
  item: MemberKickOutMessage;
}
export default function MemberKickOutChat(props) {
  const $ = _c(2);
  const {
    item
  } = props;
  const {
    message
  } = item.data;
  const t0 = `${message.type}님께서 ${message.name}님을 강퇴시켰습니다.`;
  let t1;
  if ($[0] !== t0) {
    t1 = <div className="mb-[3px] whitespace-pre-wrap text-cht_al_2"><div>{t0}</div></div>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}